import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "./ConsentPage.scss";
import Navbar from "../Navbar/Navbar";
import PatientAppBar from "../../components/PatientAppBar/PatientAppBar";

export default function ConsentPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const patientBack = state?.patientBack;

  return (
    <div className="consenall">
      {patientBack ? (
        <PatientAppBar
          title={t("consent.title")}
          backTo={patientBack.to}
          backLabel={patientBack.label || "Back"}
        />
      ) : (
      <Navbar />
      )}
      <section className="consent-page">
        <div className="container">
          <div className="consent-card">
            {/* Top Header Bar */}
            <div className="consent-card__top">
              <h1>{t("consent.title")}</h1>
            </div>

            {/* Body */}
            <div className="consent-card__body">
              <h2>{t("consent.heading")}</h2>
              <p className="consent-card__sub">{t("consent.sub")}</p>

              <div className="consent-sec">
                <h3>{t("consent.sec1.title")}</h3>
                <p>{t("consent.sec1.p1")}</p>
                <ul>
                  <li>{t("consent.sec1.li1")}</li>
                  <li>{t("consent.sec1.li2")}</li>
                  <li>{t("consent.sec1.li3")}</li>
                </ul>
                <p>{t("consent.sec1.p2")}</p>
              </div>

              <div className="consent-sec">
                <h3>{t("consent.sec2.title")}</h3>
                <p>{t("consent.sec2.p1")}</p>
                <ul>
                  <li>{t("consent.sec2.li1")}</li>
                  <li>{t("consent.sec2.li2")}</li>
                  <li>{t("consent.sec2.li3")}</li>
                </ul>
                <p>{t("consent.sec2.p2")}</p>
              </div>

              <div className="consent-sec">
                <h3>{t("consent.sec3.title")}</h3>
                <p>{t("consent.sec3.p1")}</p>
                <ul>
                  <li>{t("consent.sec3.li1")}</li>
                  <li>{t("consent.sec3.li2")}</li>
                  <li>{t("consent.sec3.li3")}</li>
                </ul>
                <p>{t("consent.sec3.p2")}</p>
              </div>

              <div className="consent-sec">
                <h3>{t("consent.sec4.title")}</h3>
                <p>{t("consent.sec4.p1")}</p>
                <p>{t("consent.sec4.p2")}</p>
                <ul>
                  <li>{t("consent.sec4.li1")}</li>
                  <li>{t("consent.sec4.li2")}</li>
                  <li>{t("consent.sec4.li3")}</li>
                </ul>
                <p>{t("consent.sec4.p3")}</p>
              </div>

              <div className="consent-sec">
                <h3>{t("consent.sec5.title")}</h3>
                <p className="muted">{t("consent.sec5.p1")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
